<template>
  <el-row class="editPanel">
    <h3 :class="{closed: !panelOpen}">Authorization</h3><span class="toggle" @click="panelOpen = panelOpen !== true" :class="{closed: !panelOpen}"></span>
    <transition name="panel">
      <div class="pea-panel" v-if="panelOpen">
        <authorization-list-popup :peaId="this.peaId" ref="authorizationPopup"></authorization-list-popup>
        <el-row>
          <el-form ref="commentForm">
            <el-col :span="6">
              <el-button type="primary" @click="showAuthorizations()">View Approval List</el-button>
            </el-col>
            <el-col :span="18">
              <b>This will show the approval list based on the data you have saved in the PEA so far. The list is based mainly on the value of the PEA but may also depend on other factors, for example division or IT expenditure. </b>
            </el-col>
          </el-form>
        </el-row>
        <br/>
      </div>
    </transition>
  </el-row>
</template>
<script>
// import router from '@/router'
export default {
  name: 'pea-authorization-preview',
  props: {
    peaId: {
      default: 0
    }
  },
  data () {
    return {
      currentPage: 1,
      pageSize: 5,
      resultTotal: 0,
      panelOpen: true
    }
  },
  methods: {
    showAuthorizations () {
      if (this.peaId !== 0) {
        // router.push('/peaAuthorizations/' + this.peaId)
        this.$refs.authorizationPopup.showAuthorizationListPopup()
      } else {

      }
    },
    startUp () {
      // eslint-disable-next-line
      if (this.peaId != 0) {
        //  this.fetchData()
      } else {
      }
    }
  },
  mounted () {
    this.startUp()
  },
  watch: {
    // watch for route change - going from pea/4 to pea/0
    '$route': 'startUp'
  }
}
</script>

<style scoped>

</style>
